import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { addAnswer } from "../../../../redux/survey/actions";
import { Box, Tooltip } from "@mui/material";
import emoji1 from "../../../../assets/images/web_rating/emoji_1.gif";
import emoji2 from "../../../../assets/images/web_rating/emoji_2.gif";
import emoji3 from "../../../../assets/images/web_rating/emoji_3.gif";
import emoji4 from "../../../../assets/images/web_rating/emoji_4.gif";
import emoji5 from "../../../../assets/images/web_rating/emoji_5.gif";
import { toast } from "react-toastify";
import { withStyles } from "@mui/styles";
import { useIntl } from "react-intl";
import { filterVisibleSurveyQuestions } from "../../../../Survey/helpers/surveyHelper";
// Array of emoji image sources
const emojiImage = [emoji1, emoji2, emoji3, emoji4, emoji5];

const EmojiType = (props) => {
  const intl = useIntl();
  // Destructuring the properties passed as props
  const {
    headTonext,
    question,
    answeres,
    addAnswer_,
    survey_theme,
    onSend,
    surveyType,
    allQuestionsOriginal,
    setAllQuestions,
    clearAnsweres_,
    currentQuestionIndex,
    hideQuestion,
    allQuestions,
    finishSurvey,
    edit_answer,
  } = props;
  // Setting up the local state for the component
  const [checked, setChecked] = useState("");
  const [isFinishSurvey, setIsFinishSurvey] = useState(false);
  // State to control the tooltip
  const [openTooltip, setOpenTooltip] = useState(null);

  // Auto-answer first question if rfid_tag is true
  useEffect(() => {
    const rfid_tag = localStorage.getItem("rfid_tag") === "true";
    if (!rfid_tag) return; // exit if rfid_tag is false

    if (currentQuestionIndex === 0) {
      const storedQuestionId = localStorage.getItem("question_id");
      const storedOptionId = localStorage.getItem("option_id");

      if (storedQuestionId === question._id && storedOptionId) {
        const option = question.options.find(
          (opt) => opt._id === storedOptionId
        );
        if (option) {
          handleChange(
            option._id,
            option.value,
            option.value - 1,
            option?.route_to_index,
            option?.hide_questions,
            option?.finish_survey === true
          );
        }
      }
    }
  }, [currentQuestionIndex, question]); // run when question changes

  const handleChange = (
    ratingId,
    value,
    text,
    routeToIndex,
    hideIndex,
    finishedSurvey
  ) => {
    setChecked(ratingId);

    if (surveyType === "tablet" && currentQuestionIndex === 0) {
      clearAnsweres_();
      // Calculating the percentage based on the value
      const percentage = (Number(value) / Number(question?.maxScore)) * 100;

      const filteredQuestion = filterVisibleSurveyQuestions(
        allQuestionsOriginal
          .filter((item) => item._id !== question._id)
          .filter((item) =>
            percentage >= 70
              ? item.journey_type === "neutral" ||
                item.journey_type === "positive"
              : item.journey_type === "neutral" ||
                item.journey_type === "negative"
          )
      );

      setAllQuestions([question, ...filteredQuestion]);
    }

    if (!finishedSurvey && hideIndex?.length) {
      hideQuestion(hideIndex);
    }
    setIsFinishSurvey(finishedSurvey);
    setOpenTooltip(ratingId);

    if (question?.required && !ratingId) {
      toast.error(intl.formatMessage({ id: "this-question-is-required" }));
      return;
    } else {
      addAnswer_({
        id: question._id,
        value: ratingId,
        type: "id",
      });

      if (!finishedSurvey && routeToIndex) {
        headTonext(routeToIndex, question._id);
      }

      onSend(text);
      const isNotEditing =
        !edit_answer || Object?.keys(edit_answer)?.length === 0;
      if (currentQuestionIndex + 1 >= allQuestions?.length && isNotEditing) {
        finishSurvey(true, question);
      }
    }
  };

  const handleTooltipClose = () => {
    setOpenTooltip(null);
  };

  // Skip the current question and finish the survey if it's the last question
  const onSkipQuestion = () => {
    onSend("");
    const isNotEditing =
      !edit_answer || Object?.keys(edit_answer)?.length === 0;
    if (currentQuestionIndex + 1 >= allQuestions?.length && isNotEditing) {
      finishSurvey(true, question);
    }
  };

  const CustomTooltip = withStyles({
    tooltip: {
      color: "white",
      backgroundColor: survey_theme?.primaryColor,
      fontSize: "0.8rem",
      top: "0.7rem",
    },
    arrow: {
      color: survey_theme?.primaryColor,
    },
  })(Tooltip);

  // Function to load data from Redux store when component mounts
  const loadData = () => {
    if (question._id in answeres) {
      setChecked(answeres[question._id]?.value);
    }
  };

  useEffect(() => {
    loadData(); // Load data from Redux store when component mounts
  }, [answeres]);

  return (
    <>
      <div className="px-2 bg-white border-t border-gray-200">
        <div className="flex items-center justify-center space-x-3 h-18 px-2">
          {question?.options
            ?.sort((a, b) => a?.value - b?.value)
            ?.map((item, index) => {
              return (
                <>
                  <Box
                    key={index}
                    className="ratingItem"
                    style={{
                      width: "20%",
                      borderRadius: "50%",
                      border:
                        answeres[question._id]?.value === item._id ||
                        checked === item?._id
                          ? "2px solid gainsboro"
                          : "2px solid white",
                      margin: "0 auto",
                    }}
                  >
                    <CustomTooltip
                      title={item?.optionText || ""}
                      placement="top"
                      open={openTooltip === item._id}
                      onClose={() => handleTooltipClose()}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      arrow
                    >
                      <img
                        alt="emoji"
                        src={emojiImage[item.value - 1]}
                        onClick={() => {
                          handleChange(
                            item._id,
                            item.value,
                            item.value - 1,
                            item?.route_to_index,
                            item?.hide_questions,
                            item?.finish_survey === true
                          );
                        }}
                        style={{ padding: "2px" }}
                        className="emoji"
                      />
                    </CustomTooltip>
                  </Box>
                </>
              );
            })}
          <div>
            {!question?.required ? (
              <button
                onClick={() => onSkipQuestion()}
                type="button"
                className="inline-flex items-center justify-center flex-1 px-3 py-2.5 text-sm font-medium leading-4 transition-all duration-200 bg-transparent border border-purple-600 rounded-full shadow-sm hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600"
              >
                {intl.formatMessage({ id: "skip" })}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};
// This is the mapStateToProps function that extracts the necessary state from the Redux store
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
    edit_answer: state.survey.edit_answer,
  };
};
// This is the mapDispatchToProps function that binds the dispatch function to action creators
const mapDispatchToProps = (dispatch) => {
  return {
    addAnswer_: (data) => dispatch(addAnswer(data)),
  };
};
// Connects the EmojiType component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(EmojiType);
